<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>서비스 신청 및 조회</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>교육 신청</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">교육 신청</p>
            <div class="row align-space-between" style="width: 100%">
                <div
                    id="education-info"
                    style="display: flex; align-content: center"
                ></div>
            </div>
        </div>

        <div id="search" class="column screen-width">
            <p style="font-size: 28px; font-weight: bold">
                신청할 교육을 검색해보세요
            </p>
            <search-bar :size="100" v-on:onSearch="searchLecture"></search-bar>
            <div class="row" style="gap: 32px">
                <a class="search-tag"> #플로터 기능 </a>
                <a class="search-tag"> #플로터 기능 </a>
                <a class="search-tag"> #플로터 기능 </a>
                <a class="search-tag"> #플로터 기능 </a>
            </div>
        </div>

        <div id="data" class="screen-width">
            <div class="row" style="gap: 14px; margin-bottom: 16px">
                <p
                    style="font-size: 28px; font-weight: bold; color: #00a7e7"
                ></p>
                <p style="font-size: 28px; font-weight: bold">강의 목록</p>
            </div>
            <div id="data-list">
                <class-item
                    v-for="(lecture, index) in lectureList"
                    :key="index"
                    :title="lecture.title"
                    :enrollAndCapacity="`${lecture.enrollments}/${lecture.capacity}`"
                    :date="lecture.date"
                    :classId="lecture.id"
                    :checked="lecture.id == lectureId"
                    :lecture="lecture"
                    v-on:checked="selectLecture"
                >
                </class-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentPage"
                :totalPages="totalPages"
                v-on:update="loadPageData"
            ></custom-pagination>
        </div>

        <div id="customer" class="column screen-width">
            <div class="row align-space-between">
                <p style="font-size: 32px; font-weight: bold">신청 고객 정보</p>
                <div class="row" style="gap: 16px">
                    <text-button
                        :textSize="20"
                        :buttonName="'회원'"
                        :buttonStyle="{
                            width: '100px',
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="goLogin"
                        :clicked="isAuth"
                    />
                    <text-button
                        :textSize="20"
                        :buttonName="'비회원'"
                        :buttonStyle="{
                            width: '100px',
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="selectSubCategory(index)"
                        :disabled="isAuth"
                        :clicked="!isAuth"
                    />
                </div>
            </div>
            <div 
                style="
                    width:100%;
                    height: 1px;
                    background: gray;
                    margin-top: 24px;
                "
            ></div>

            <div class="column" style="gap: 40px; margin-top: 48px">
                <div class="row align-space-between">
                    <p style="font-size: 28px; font-weight: bold">
                        접수시 성명
                    </p>
                    <input
                        type="text"
                        v-model="userName"
                        style="
                            width: 60%;
                            height: 56px;
                            border-bottom: 1px solid #b4b4b4;
                            padding: 12px;
                        "
                        :disabled="isAuth"
                        placeholder="접수시 성명을 입력해주세요."
                    />
                </div>
                <div class="row align-space-between">
                    <p style="font-size: 28px; font-weight: bold">연락처</p>
                    <input
                        type="text"
                        v-model="phoneNumber"
                        style="
                            width: 60%;
                            height: 56px;
                            border-bottom: 1px solid #b4b4b4;
                            padding: 12px;
                        "
                        :disabled="isAuth"
                        placeholder="'-'없이 휴대폰 번호를 입력해주세요"
                    />
                </div>
                <div>
                    <div class="row align-space-between">
                        <p style="font-size: 28px; font-weight: bold">주소</p>
                        <div class="row align-space-between" style="width: 60%">
                            <input
                                type="text"
                                v-model="roadAddress"
                                style="
                                    width: 80%;
                                    height: 56px;
                                    border-bottom: 1px solid #b4b4b4;
                                    padding: 12px;
                                "
                                :disabled="isAuth"
                                placeholder="주소를 검색하여 선택해주세요"
                            />
                            <button
                                class="align-center"
                                style="
                                    width: 12%;
                                    height: 56px;
                                    border: 1px solid black;
                                    border-radius: 25px;
                                    font-weight: bold;
                                "
                                @click="openPostCode"
                            >
                                검색
                            </button>
                        </div>
                    </div>
                    <div
                        class="row"
                        style="
                            justify-content: end;
                            align-items: center;
                            margin-top: 20px;
                        "
                    >
                        <input
                            type="text"
                            v-model="detailAddress"
                            style="
                                width: 60%;
                                height: 56px;
                                border-bottom: 1px solid #b4b4b4;
                                padding: 12px;
                            "
                            placeholder="상세 주소를 입력해주세요"
                        />
                    </div>
                </div>
                 <div class="row align-space-between" 
                        v-if="!userProfile">
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">비밀번호(4자리)</p>
                        <p
                            style="
                                font-size: 24px;
                                color: gray;
                                margin-left: 16px;
                            "
                        >
                            *
                        </p>
                    </div>
                    <input
                        type="text"
                        v-model="pinNumber"
                        maxlength="4" 
                        style="
                            width: 60%;
                            height: 56px;
                            border-bottom: 1px solid #b4b4b4;
                            padding: 12px;
                        "
                        placeholder="숫자로 구성된 4자리 핀번호를 입력해주세요"
                        @input="validatePinNumber"
                    />
                </div>
                <div class="row align-space-between">
                    <p style="font-size: 28px; font-weight: bold">
                        개인정보 수집 • 이용 동의
                    </p>
                    <div class="row align-space-between" style="width: 40%">
                        <div class="row" style="gap: 40px">
                            <input
                                type="radio"
                                v-model="isAgree"
                                :value="true"
                                style="width: 40px"
                            />
                            <p style="font-size: 24px">동의</p>
                        </div>
                        <div class="row" style="gap: 40px">
                            <input
                                type="radio"
                                v-model="isAgree"
                                :value="false"
                                style="width: 40px"
                            />
                            <p style="font-size: 24px">동의 안함</p>
                        </div>
                    </div>
                </div>
                <div
                    style="
                        width: 100%;
                        height: auto;
                        border-radius: 20px;
                        border: 1px solid #d9d9d9;
                        padding: 32px;
                    "
                >
                    <p>고객님의 원활한 서비스 신청, 상담, 이력관리 등을 위해 개인정보 수집 및 이용 동의를 받고 있습니다.</p>
                    <br>
                    <p><strong>수집 항목:</strong> 성명, 전화번호, 주소</p>
                    <br>
                    <p><strong>수집 · 이용 목적:</strong> 제품 A/S 및 B/S, 상담, 제품 교환/환불, 고객만족도 조사</p>
                    <br>
                    <p><strong>보유·이용 기간:</strong> 5년 (수정되는 정보 포함)</p>
                    <p>(단, 상법 등 타 법령에 따른 정보는 해당 법령에서 정한 기간 보존)</p>

                    <p>※ 귀하께서는 본 동의를 거절하실 수 있으나, 미동의 시 해당 서비스 신청 및 이용에 제약이 있을 수 있습니다.</p>

                    <p>※ 개인정보 처리에 대한 상세한 사항은 화면 하단의 개인정보 처리방침을 참조하십시오.</p>
                    <br>
                    <p><strong>개인정보 입력 시 주의사항</strong></p>
                    <p>- 개인정보 보호를 위해 본인 외 타인의 정보(가족 포함)는 입력이 불가합니다.</p>
                    <p>- 잘못된 정보 제공으로 인한 책임은 정보 제공자에게 있으니 주의해 주시기 바랍니다.</p>
                    <p>- 본 화면에 입력하신 개인정보는 실제 서비스(상담)나 상품 주문 등을 신청해야 수집이 되며, 그 외에는 수집 또는 저장되지 않습니다.</p>
                </div>
            </div>
        </div>

        <button
            style="
                width: 640px;
                height: 100px;
                background: #27afe2;
                border-radius: 20px;
                color: white;
                font-size: 40px;
                font-weight: bold;
            "
            @click="submit"
        >
            접수 완료
        </button>
    </v-container>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import DownloadItem from "@/components/DownloadItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import ClassItem from "@/components/ClassItem.vue";

export default {
    props: {
        category: {
            type: String,
            default: "GPS플로터",
        },
    },
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        DownloadItem,
        CustomPagination,
        ClassItem,
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const isAuth = ref(false);
        const search = ref("");

        onMounted(async () => {
            try {
                getLectureList()
                const userProfile = await store.dispatch("getUserProfile");
                userId.value = userProfile.id;
                userName.value = userProfile.name;
                phoneNumber.value = userProfile.phone_number;
                if (userProfile.address.split(":").length == 2) {
                    roadAddress.value = userProfile.address.split(":")[0];
                    detailAddress.value = userProfile.address.split(":")[1];
                }
                isAuth.value = true;
            } catch (err) {
                console.log(err);
                isAuth.value = false;
            }
        });

        const getLectureList = () => {
            store.dispatch("getLectureList", {
                search: search.value
            });
        }

        const searchLecture = (text) => {
            search.value = text
            getLectureList();
        }

        const openPostCode = () => {
            new window.daum.Postcode({
                oncomplete: (data) => {
                    roadAddress.value = data.roadAddress;
                },
            }).open();
        };


        const lectureList = computed(() => {
            return store.getters.getLectureList;
        });

        const currentPage = ref(1);
        const totalPages = computed(() => {
            return Math.ceil(store.getters.getLectureTotalCount / 10);
        });

        const loadPageData = (page) => {
            currentPage.value = page;
        };

        const userId = ref(null);
        const userName = ref("");
        const phoneNumber = ref("");
        const roadAddress = ref("");
        const detailAddress = ref("");
        const pinNumber = ref("");
        const isAgree = ref(false);

        const lectureId = ref(null);
        const selectLecture = (id) => {
            lectureId.value = id;
        };

        const submit = async () => {
            if (!isAccess.value) {
                alert("입력되지 않거나 형식이 잘못된 정보가 있습니다.");
                return;
            }
            store
                .dispatch("applyLecture", {
                    lectureId: lectureId.value,
                    userId: userId.value,
                    userName: userName.value,
                    phoneNumber: phoneNumber.value,
                    address: roadAddress.value + ":" + detailAddress.value,
                    pin: pinNumber.value
                })
                .then(() => {
                    alert("교육 신청이 완료되었습니다.");
                    router.replace({ path: "/service/check" });
                })
                .catch((err) => {
                    console.log(err);
                    if (err.response.data.message !== "이미 신청한 교육입니다.") {
                        alert("교육 신청이 에러가 발생하였습니다.");
                    } else {
                        alert(err.response.data.message)
                    }
                });
        };

        const userProfile = computed(() => {
            return store.getters.getUserProfile;
        });

        const goLogin = () => {
            if (!isAuth.value) {
                router.push({ path: "/login" });
            }
        };
        
        // 모든 필드가 입력되었는지 확인
        const isAccess = computed(() => {
            return (
                lectureId.value &&
                userName.value &&
                phoneNumber.value &&
                phoneNumber.value.length >= 10 &&
                (isAuth.value || pinNumber.value) && 
                roadAddress.value &&
                detailAddress.value &&
                isAgree.value
            );
        });

        const validatePinNumber = (event) => {
            let value = event.target.value;
            // 숫자가 아닌 문자 제거 & 최대 4자리 제한
            value = value.replace(/[^0-9]/g, "").slice(0, 4);
            pinNumber.value = value;
        };

        
        return {
            isAgree,
            currentPage,
            totalPages,
            loadPageData,
            selectLecture,
            lectureId,
            lectureList,
            userName,
            phoneNumber,
            roadAddress,
            detailAddress,
            submit,
            userProfile,
            isAuth,
            goLogin,
            validatePinNumber,
            pinNumber,
            searchLecture,
            openPostCode
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

#education-info {
    width: 100%;
    height: 200px;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}

#search {
    padding: 32px 0px;
    gap: 24px;
}

#customer {
    padding: 40px 0px;
}

textarea {
    padding: 10px;
    resize: none;
    border: none;
}
textarea:focus {
    outline: none !important;
}
input:focus {
    outline: none !important;
}

#data {
    padding: 32px 0px;
}

#data-list {
    width: 100%;
    border-top: 1px solid black;
}
</style>
